import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { FeedbackPanelTabsComponent } from './feedback-panel-tabs.component';

export const ngxFeedbackPanelTabsModule = angular.module('ngxFeedbackPanelTabsModule', [])
	.directive('ngxFeedbackPanelTabs', downgradeComponent({ component: FeedbackPanelTabsComponent }))
	.name;
